export enum LearningActivityType {
    DAY = 'day',
    WEEK = 'week',
}
